/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReplyOutlinedIcon = /*#__PURE__*/ createSvgIcon(
  'ReplyOutlinedIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.38 1.887V6.36h2.42c1.916 0 3.851.677 5.307 2.16 1.459 1.486 2.393 3.736 2.393 6.8v1.46l-.895-1.154c-.8-1.031-2.023-1.572-3.207-1.85-1.178-.275-2.254-.276-2.698-.276H9.38v4.613L.247 10 9.38 1.887zM1.753 10l6.627 5.887V12.5h4.323c.459 0 1.63 0 2.924.303.923.217 1.942.595 2.814 1.265-.215-2.194-.997-3.778-2.048-4.848-1.244-1.267-2.91-1.86-4.593-1.86H8.38V4.113L1.753 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ReplyOutlinedIcon;
